"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * FileData type guard.
 */
exports.isFileData = function (data) {
    return (data !== undefined &&
        ((typeof Blob !== 'undefined' && data instanceof Blob) ||
            (typeof File !== 'undefined' && data instanceof File) ||
            (typeof Buffer !== 'undefined' && data instanceof Buffer)));
};
/**
 * Uuid type guard.
 */
exports.isUuid = function (data) {
    var UUID_REGEX = '[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}';
    var regExp = new RegExp(UUID_REGEX);
    return !exports.isFileData(data) && regExp.test(data);
};
/**
 * Url type guard.
 *
 * @param {NodeFile | BrowserFile | Url | Uuid} data
 */
exports.isUrl = function (data) {
    var URL_REGEX = '^(?:\\w+:)?\\/\\/([^\\s\\.]+\\.\\S{2}|localhost[\\:?\\d]*)\\S*$';
    var regExp = new RegExp(URL_REGEX);
    return !exports.isFileData(data) && regExp.test(data);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/uploadFile/types.js
// module id = 651
// module chunks = 71